import { createContext, PropsWithChildren, useEffect, useRef } from 'react';
import { ApiEndpoints } from '../../../constants/endpoints/apiEndpoints.ts';
import { workflowRpcClient } from '../../../features/workflow/hub/workflowRpcClient';
import { workflowRpcServer } from '../../../features/workflow/hub/workflowRpcServer';
import { workflowDataType } from '../../../features/workflow/types';
import { globalRef, createHubStore } from '../../../util/hubs/hubStore';

export type WorkflowStoreType = ReturnType<typeof createHubStore<workflowRpcServer, workflowDataType>>;
export const WorkflowContext = createContext<WorkflowStoreType | null>(null);
export const WorkflowConnection = (props: PropsWithChildren) => {
  const hubRef = useRef(globalRef()).current;
  const storeRef = useRef(
    createHubStore<workflowRpcServer, workflowDataType>(
      hubRef,
      ApiEndpoints.hubs.workFlowHubV2,
      {},
      workflowRpcClient,
      (state) => ({
        inactive: state.inactive,
        updateConnectionType: state.updateConnectionType,
        user: state.user ? { ...state.user } : undefined,
        users: Object.fromEntries(
          Object.entries(state.users ?? {}).map(([id, user]) => [
            id,
            {
              ...user,
              Scores: { ...(user.Scores ?? {}) },
              Shift: user.Shift ? { ...user.Shift } : undefined,
              Lunch: user.Lunch ? { ...user.Lunch } : undefined
            }
          ])
        ),
        schedule: Object.fromEntries(
          Object.entries(state.schedule ?? {}).map(([id, sched]) => [
            id,
            {
              ...sched,
              Shift: sched.Shift ? { ...sched.Shift } : undefined,
              Lunch: sched.Lunch ? { ...sched.Lunch } : undefined
            }
          ])
        )
      }),
      'OnAutoJoin'
    )
  ).current;
  useEffect(() => {
    storeRef.getState().connect();
  }, []);
  return <WorkflowContext.Provider value={storeRef}>{props.children}</WorkflowContext.Provider>;
};
